module.exports = __webpack_public_path__ + "img/68_48.5d8281ee.png";